import { TreatPropertyAs } from '@taxfyle/txf-api-client'

const RENTAL_ACTIVITY_TYPES_MAP: Record<TreatPropertyAs, string> = {
  [TreatPropertyAs.ActiveRentalEstate]: 'Active Rental Real Estate',
  [TreatPropertyAs.OtherPassive]: 'Other Passive',
  [TreatPropertyAs.RealEstateProfessional]: 'Real Estate Professional',
  [TreatPropertyAs.NonPassive]: 'Non-Passive',
} as const

export const RENTAL_ACTIVITY_TYPES = Object.entries(
  RENTAL_ACTIVITY_TYPES_MAP,
) as [code: TreatPropertyAs, label: string][]
